export const OFFICE_LABELS = {
  president: 'President',
  vice_president: 'Vice President',
  treasurer: 'Treasurer',
  secretary: 'Secretary',
  member: 'Member'
};
